import { Component, Inject } from '@angular/core';
import { DigisubservicesService } from '../services/digisubservices.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-lekh-report',
  templateUrl: './lekh-report.component.html',
  styleUrl: './lekh-report.component.scss'
})
export class LekhReportComponent {

  issueMonth: string = '';
  reportData: any[] = [];
  loading: boolean = false;
  errorMsg: string = '';

  constructor(public dialogRef: MatDialogRef<LekhReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService) { }

  ngOnInit(): void {
    this.issueMonth = this.data['month'];
  }

  getLekhReport() {
    if (!this.issueMonth) {
      this.errorMsg = 'Please select issue month';
      return;
    }

    this.loading = true;
    this.errorMsg = '';

    this.service.getLekhReport(this.issueMonth).subscribe({
      next: (res) => {
        if (res.status === 'success') {
          this.reportData = res.data;
        } else {
          this.errorMsg = res.message || 'Failed to load report';
        }
        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.errorMsg = 'Server error while fetching report';
        this.loading = false;
      }
    });
  }

}